import Vue from 'vue';
import Vuex from 'vuex';
import {  get_server_time } from '@/api/home'
Vue.use(Vuex);

const SWITCH_AUTH_DURATION = 60 * 60 * 1000;

function getSwitchWithExpiry(key, defaultValue) {
  const timeKey = key + 'Time';
  const value = localStorage.getItem(key);
  const savedTime = localStorage.getItem(timeKey);
  
  if (value === null) {
    return defaultValue;
  }
  
  if (savedTime) {
    const elapsed = Date.now() - parseInt(savedTime);
    if (elapsed >= SWITCH_AUTH_DURATION) {
      localStorage.removeItem(key);
      localStorage.removeItem(timeKey);
      return defaultValue;
    }
  }
  
  return JSON.parse(value);
}

function setSwitchWithExpiry(key, value) {
  const timeKey = key + 'Time';
  localStorage.setItem(key, JSON.stringify(value));
  localStorage.setItem(timeKey, Date.now().toString());
}

export default new Vuex.Store({
  state: {
    loginData: JSON.parse(localStorage.getItem('zhimingLoginData')) || null,
    userTokenData: JSON.parse(localStorage.getItem('zhimingUserTokenData')) || null,
    oauthUserInfo: JSON.parse(localStorage.getItem('zhimingOauthUserInfo')) || null,
    oauthAccessToken: localStorage.getItem('zhimingOauthAccessToken') || null,
    oauthOpenId: localStorage.getItem('zhimingOauthOpenId') || null,
    loginType: JSON.parse(localStorage.getItem('zhimingLoginType')) || null,
    menuId: JSON.parse(localStorage.getItem('zhimingMenuId')) || null,
    classId: JSON.parse(localStorage.getItem('zhimingClassId')) || null,
    subjectId: JSON.parse(localStorage.getItem('zhimingSubjectId')) || null,
    subjectName: localStorage.getItem('zhimingSubjectName') || null,
    versionId: JSON.parse(localStorage.getItem('zhimingVersionId')) || null,
    semesterId: JSON.parse(localStorage.getItem('zhimingSemesterId')) || null,
    semesterName: localStorage.getItem('zhimingSemesterName') || null,
    chapterId: JSON.parse(localStorage.getItem('zhimingChapterId')) || null,
    planData: JSON.parse(localStorage.getItem('zhimingPlanData')) || null,
    chapterName: JSON.parse(localStorage.getItem('zhimingChapterName')) || null,  //这个是点击计划才会保存的章节名称
    topicData: JSON.parse(localStorage.getItem('zhimingTopicData')) || null,
    setId: JSON.parse(localStorage.getItem('zhimingSetId')) || null,
    studentInfo: JSON.parse(localStorage.getItem('zhimingStudentInfo')) || null,
    isFirstTitleExists: localStorage.getItem('zhimingIsFirstTitleExists'), //组合作文是否有标题 有第一个答题区域居中
    pictureSize: null,
    originScale: sessionStorage.getItem('OriginScale') || 1, //讲解 缩放大小
    activeStudent: JSON.parse(sessionStorage.getItem('zhimingActiveStudent')) || [],
    activeGroup: [],
    activeNumber: 2,
    groupNumber: 2,
    manualCorrectionBtnShow: getSwitchWithExpiry('zhimingManualCorrectionBtnShow', false),
    reportRank: JSON.parse(localStorage.getItem('zhimingReportRank')) || 25,
    speed: JSON.parse(localStorage.getItem('getSpeed')) || 1000,
    correctStudentList: sessionStorage.getItem('CorrectStudentList') ? JSON.parse(sessionStorage.getItem('CorrectStudentList')) : [], //批改了的学生数据
    isFullScreen: JSON.parse(sessionStorage.getItem('IsFullScreen')) || false,
    coursewareList: (() => { try { return JSON.parse(localStorage.getItem('zhimingCoursewareList')) || null } catch (e) { localStorage.removeItem('zhimingCoursewareList'); return null } })(),
    coursewarevideoList: (() => { try { return JSON.parse(localStorage.getItem('zhimingCoursewareVideoList')) || null } catch (e) { localStorage.removeItem('zhimingCoursewareVideoList'); return null } })(),
    dialogVisibleTime: false,
    openChongPi: getSwitchWithExpiry('zhimingOpenChongPi', false),
    openBiaoXian: getSwitchWithExpiry('zhimingOpenBiaoXian', false),
    
    opendel: getSwitchWithExpiry('zhimingOpendel', false),
    openUnCommit: getSwitchWithExpiry('zhimingOpenUnCommit', false),
    showStudentName: localStorage.getItem('zhimingShowStudentName') !== 'false',
    openStrokeCal: getSwitchWithExpiry('zhimingOpenStrokeCal', false),
    strokeSettings: (() => {
      const defaults = {
        realtimeColor: '#000000',
        realtimeLineWidth: 0.1,
        historyColor: '#000000',
        historyLineWidth: 0.1
      }
      try {
        const stored = localStorage.getItem('zhimingStrokeSettings')
        if (stored) {
          const parsed = JSON.parse(stored)
          if (parsed && typeof parsed === 'object') {
            const settings = { ...defaults, ...parsed }
            localStorage.setItem('zhimingStrokeSettings', JSON.stringify(settings))
            return settings
          }
        }
      } catch (e) {}
      localStorage.setItem('zhimingStrokeSettings', JSON.stringify(defaults))
      return defaults
    })(),
    onlyofficeUrl: 'https://api.youcun.tech', // OnlyOffice回调走网关
    pingjiaTime:null,
    starSettings: (() => {
      try {
        const stored = localStorage.getItem('zhimingStarSettings')
        const parsed = stored ? JSON.parse(stored) : null
        return parsed?.totalStars ? parsed : {
          totalStars: 5,
          starRanges: [
            { min: 0, max: 29 },
            { min: 30, max: 59 },
            { min: 60, max: 75 },
            { min: 76, max: 85 },
            { min: 86, max: 100 }
          ]
        }
      } catch (e) {
        return {
          totalStars: 5,
          starRanges: [
            { min: 0, max: 29 },
            { min: 30, max: 59 },
            { min: 60, max: 75 },
            { min: 76, max: 85 },
            { min: 86, max: 100 }
          ]
        }
      }
    })()
  },
  mutations: {
    changepingjiatime(state, value) { 
      state.pingjiaTime = value;
    },
    setDialogVisibleTime(state, value) {
      state.dialogVisibleTime = value;
    },
    
    getopenChongPi(state,value) {
      state.openChongPi=value;
      setSwitchWithExpiry('zhimingOpenChongPi', value);
    },
    getopenopenBiaoXian(state,value) {
      state.openBiaoXian =value;
      setSwitchWithExpiry('zhimingOpenBiaoXian', value);
    },
    getopendel(state,value) {
      state.opendel =value;
      setSwitchWithExpiry('zhimingOpendel', value);
    },
    getopenUnCommit(state,value) {
      state.openUnCommit =value;
      setSwitchWithExpiry('zhimingOpenUnCommit', value);
    },
    setShowStudentName(state, value) {
      state.showStudentName = value;
      localStorage.setItem('zhimingShowStudentName', String(value));
    },
    getopenStrokeCal(state,value) {
      state.openStrokeCal =value;
      setSwitchWithExpiry('zhimingOpenStrokeCal', value);
    },
    getStrokeSettings(state, value) {
      if (!value || typeof value !== 'object') return
      state.strokeSettings = value;
      localStorage.setItem('zhimingStrokeSettings', JSON.stringify(value))
    },
    getStarSettings(state, value) {
      const defaultSettings = {
        totalStars: 5,
        starRanges: [
          { min: 0, max: 29 },
          { min: 30, max: 59 },
          { min: 60, max: 75 },
          { min: 76, max: 85 },
          { min: 86, max: 100 }
        ]
      }
      const validValue = value?.totalStars ? value : defaultSettings
      state.starSettings = validValue;
      localStorage.setItem('zhimingStarSettings', JSON.stringify(validValue))
    },
    getLoginData(state, n) {
      state.loginData = n;
      localStorage.setItem('zhimingLoginData', JSON.stringify(n))
    },
    getUserTokenData(state, n) {
      state.userTokenData = n;
      localStorage.setItem('zhimingUserTokenData', JSON.stringify(n))
    },
    getLoginType(state, n) {
      state.loginType = n;
      localStorage.setItem('zhimingLoginType', JSON.stringify(n))
    },
    getOauthUserInfo(state, n) {
      state.oauthUserInfo = n;
      localStorage.setItem('zhimingOauthUserInfo', JSON.stringify(n))
    },
    getOauthAccessToken(state, n) {
      state.oauthAccessToken = n;
      localStorage.setItem('zhimingOauthAccessToken', n)
    },
    getOauthOpenId(state, n) {
      state.oauthOpenId = n;
      localStorage.setItem('zhimingOauthOpenId', n)
    },
    getSubjectId(state, n) {
      state.subjectId = n;
      localStorage.setItem('zhimingSubjectId', JSON.stringify(n))
    },
    getSubjectName(state, n) {
      state.subjectName = n;
      localStorage.setItem('zhimingSubjectName', n)
    },
    getMenuId(state, n) {
      state.menuId = n;
      localStorage.setItem('zhimingMenuId', JSON.stringify(n))
    },
    getClassId(state, n) {
      state.classId = n;
      localStorage.setItem('zhimingClassId', JSON.stringify(n))
    },
    getVersionId(state, n) {
      state.versionId = n;
      localStorage.setItem('zhimingVersionId', JSON.stringify(n))
    },
    getSemesterId(state, n) {
      state.semesterId = n;
      localStorage.setItem('zhimingSemesterId', JSON.stringify(n))
    },
    getSemesterName(state, n) {
      state.semesterName = n;
      localStorage.setItem('zhimingSemesterName', n)
    },
    getChapterId(state, n) {
      state.chapterId = n;
      localStorage.setItem('zhimingChapterId', JSON.stringify(n))
    },
    getPlanData(state, n) {
      state.planData = n;
      localStorage.setItem('zhimingPlanData', JSON.stringify(n))
    },
    getChapterName(state, n) {
      state.chapterName = n;
      localStorage.setItem('zhimingChapterName', JSON.stringify(n))
    },
    getTopicData(state, n) {
      state.topicData = n;
      localStorage.setItem('zhimingTopicData', JSON.stringify(n))
    },
    getSetId(state, n) {
      state.setId = n;
      localStorage.setItem('zhimingSetId', JSON.stringify(n))
    },
    getStudentInfo(state, n) {
      state.studentInfo = n;
      localStorage.setItem('zhimingStudentInfo', JSON.stringify(n))
    },
    getIsFirstTitleExists(state, n) {
      state.isFirstTitleExists = n;
      localStorage.setItem('zhimingIsFirstTitleExists', n)
    },
    getPictureSize(state, n) {
      state.pictureSize = n;
    },
    getOriginScale(state, n) {
      state.originScale = n;
      sessionStorage.setItem('OriginScale', state.originScale);
    },
    getActiveStudent(state, n) {
      state.activeStudent = n
      sessionStorage.setItem('zhimingActiveStudent', JSON.stringify(state.activeStudent))
    },
    getActiveGroup(state, n) {
      state.activeGroup = n || [];
    },
    getGroupNumber(state, n) {
      state.groupNumber = n;
    },
    getActiveNumber(state, n) {
      state.activeNumber = n;
    },
    getManualCorrectionBtnShow(state, n) {
      state.manualCorrectionBtnShow = n;
      setSwitchWithExpiry('zhimingManualCorrectionBtnShow', n);
    },
    getReportRank(state, n) {
      state.reportRank = n;
      localStorage.setItem('zhimingReportRank', JSON.stringify(n))
    },
    getSpeed(state, n) {
      state.speed = n;
      localStorage.setItem('getSpeed', JSON.stringify(n))
    },
    getCorrectStudentList(state, n) {
      state.correctStudentList = n;
      sessionStorage.setItem('CorrectStudentList', JSON.stringify(state.correctStudentList));
    },
    getIsFullScreen(state, n) {
      state.isFullScreen = n;
      sessionStorage.setItem('IsFullScreen', JSON.stringify(n));
    },
    getCoursewareList(state, n) {
      state.coursewareList = n;
      if (n) {
        localStorage.setItem('zhimingCoursewareList', JSON.stringify(n))
      } else {
        localStorage.removeItem('zhimingCoursewareList')
      }
    },
    getCoursewarevideoList(state, n) {
      state.coursewarevideoList = n;
      if (n) {
        localStorage.setItem('zhimingCoursewareVideoList', JSON.stringify(n))
      } else {
        localStorage.removeItem('zhimingCoursewareVideoList')
      }
    },
  },
  actions: {
    async checkServerTime({ commit }) {
      try {
        const response = await get_server_time();
        let plan_bgin_time = JSON.parse(localStorage.getItem('query_plan_time_by_room_id_class_id_plan_id_result'))
        // 只看老师统一时段(2026-09-22 pad学生段方案): 接口已混合学生个人作答段,
        // [last]不筛teacher会取到学生段,把"距下课<10分钟"的延时提示错判到学生作答时刻
        const teacherTimes = (plan_bgin_time || []).filter(item => item.time_type === 'teacher')
        const activeTimes = teacherTimes.length ? teacherTimes : plan_bgin_time
        const timeDifference = Math.abs(activeTimes[activeTimes.length-1].end_time - response.data.result.timestamp) / 60000;
        if (timeDifference < 10) {
          commit('setDialogVisibleTime', true);
        }
      } catch (error) {
      }
    },
    resetStore({ state }) {
      const defaults = {
        loginData: null,
        userTokenData: null,
        oauthUserInfo: null,
        oauthAccessToken: null,
        oauthOpenId: null,
        loginType: null,
        menuId: null,
        classId: null,
        subjectId: null,
        subjectName: null,
        versionId: null,
        semesterId: null,
        semesterName: null,
        chapterId: null,
        planData: null,
        chapterName: null,
        topicData: null,
        setId: null,
        studentInfo: null,
        isFirstTitleExists: null,
        pictureSize: null,
        originScale: 1,
        activeStudent: [],
        activeGroup: [],
        activeNumber: 2,
        groupNumber: 2,
        manualCorrectionBtnShow: false,
        reportRank: 25,
        speed: 1000,
        correctStudentList: [],
        isFullScreen: false,
        coursewareList: null,
        coursewarevideoList: null,
        dialogVisibleTime: false,
        openChongPi: false,
        openBiaoXian: false,
        opendel: false,
        openUnCommit: false,
        showStudentName: true,
        openStrokeCal: false,
        strokeSettings: {
          realtimeColor: '#000000',
          realtimeLineWidth: 0.1,
          historyColor: '#000000',
          historyLineWidth: 0.1
        },
        onlyofficeUrl: 'https://api.youcun.tech', // OnlyOffice回调走网关
        pingjiaTime: null,
        starSettings: {
          totalStars: 5,
          starRanges: [
            { min: 0, max: 29 },
            { min: 30, max: 59 },
            { min: 60, max: 75 },
            { min: 76, max: 85 },
            { min: 86, max: 100 }
          ]
        }
      }
      for (let key in defaults) {
        state[key] = defaults[key]
      }
      localStorage.removeItem('zhimingLoginData')
      localStorage.removeItem('zhimingUserTokenData')
      localStorage.removeItem('zhimingOauthUserInfo')
      localStorage.removeItem('zhimingOauthAccessToken')
      localStorage.removeItem('zhimingOauthOpenId')
      localStorage.removeItem('zhimingLoginType')
      localStorage.removeItem('zhimingMenuId')
      localStorage.removeItem('zhimingClassId')
      localStorage.removeItem('zhimingSubjectId')
      localStorage.removeItem('zhimingSubjectName')
      localStorage.removeItem('zhimingVersionId')
      localStorage.removeItem('zhimingSemesterId')
      localStorage.removeItem('zhimingSemesterName')
      localStorage.removeItem('zhimingChapterId')
      localStorage.removeItem('zhimingPlanData')
      localStorage.removeItem('zhimingChapterName')
      localStorage.removeItem('zhimingTopicData')
      localStorage.removeItem('zhimingSetId')
      localStorage.removeItem('zhimingStudentInfo')
      localStorage.removeItem('zhimingIsFirstTitleExists')
      localStorage.removeItem('zhimingReportRank')
      localStorage.removeItem('getSpeed')
      localStorage.removeItem('zhimingCoursewareList')
      localStorage.removeItem('zhimingCoursewareVideoList')
      localStorage.removeItem('zhimingOpenChongPi')
      localStorage.removeItem('zhimingOpenChongPiTime')
      localStorage.removeItem('zhimingOpenBiaoXian')
      localStorage.removeItem('zhimingOpenBiaoXianTime')
      localStorage.removeItem('zhimingOpendel')
      localStorage.removeItem('zhimingOpendelTime')
      localStorage.removeItem('zhimingOpenUnCommit')
      localStorage.removeItem('zhimingOpenUnCommitTime')
      localStorage.removeItem('zhimingShowStudentName')
      localStorage.removeItem('zhimingOpenStrokeCal')
      localStorage.removeItem('zhimingOpenStrokeCalTime')
      localStorage.removeItem('zhimingManualCorrectionBtnShow')
      localStorage.removeItem('zhimingManualCorrectionBtnShowTime')
      localStorage.removeItem('zhimingStrokeSettings')
      localStorage.removeItem('zhimingStarSettings')
      localStorage.removeItem('currentGoBack')
      localStorage.removeItem('huancunStudentNumber')
      localStorage.removeItem('dotsBig')
      localStorage.removeItem('plan_end_time')
      localStorage.removeItem('AllgroupList')
      localStorage.removeItem('notify')
      sessionStorage.removeItem('zhimingActiveStudent')
      sessionStorage.removeItem('OriginScale')
      sessionStorage.removeItem('CorrectStudentList')
      sessionStorage.removeItem('IsFullScreen')
    },
  },
  modules: {},
});
